module.exports = __webpack_public_path__ + "629a5694f1172d94f69c6d7d612b4442.svg";